import { Info, X } from "lucide-react"; // Use Info icon for info modals
import { createPortal } from "react-dom";

const ConfirmDialog = ({
  open,
  title = "Confirm Action",
  description,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  loading = false,
  variant = "danger", // danger | warning | info
}) => {
  if (!open) return null;

  const VARIANT_STYLES = {
    danger: {
      iconBg: "bg-red-100",
      iconText: "text-red-600",
      button: "bg-red-600 hover:bg-red-700",
      icon: <span className="text-lg font-bold text-red-600">!</span>,
    },
    warning: {
      iconBg: "bg-yellow-100",
      iconText: "text-yellow-600",
      button: "bg-yellow-600 hover:bg-yellow-700",
      icon: <span className="text-lg font-bold text-yellow-600">!</span>,
    },
    info: {
      iconBg: "bg-blue-100",
      iconText: "text-blue-600",
      button: "bg-blue-600 hover:bg-blue-700",
      icon: <Info size={28} className="text-blue-600" />,
    },
  };

  const styles = VARIANT_STYLES[variant];

  return createPortal(
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      {/* BACKDROP */}
      <div
        className="absolute inset-0 bg-black/50"
        onClick={onCancel}
      />

      {/* MODAL */}
      <div
        className="
          relative bg-white rounded-xl shadow-xl
          w-[98%] max-w-sm sm:max-w-lg
          mx-auto p-6
        "
      >
        {/* HEADER */}
        <div className="flex items-center gap-3 mb-4">
          <div
            className={`w-11 h-11 rounded-full flex items-center justify-center ${styles.iconBg}`}
          >
            {styles.icon}
          </div>
          <h2 className="text-lg font-bold text-gray-900 flex-1">{title}</h2>
          <button
            onClick={onCancel}
            className="text-gray-400 hover:text-gray-600"
          >
            <X size={20} />
          </button>
        </div>

        {/* DESCRIPTION */}
        {description && (
          <div className="text-gray-700 text-[15px] mb-6">{description}</div>
        )}

       
        {/* ACTIONS */}
<div className="flex justify-end gap-3 mt-6">

  {/* Cancel Button (only if cancelText exists) */}
  {cancelText && (
    <button
      onClick={onCancel}
      disabled={loading}
      className="px-4 py-2 rounded-lg text-sm font-medium 
      bg-gray-100 text-gray-700 hover:bg-gray-200 transition"
    >
      {cancelText}
    </button>
  )}

  {/* Confirm Button */}
  {confirmText && (
    <button
  onClick={onConfirm}
  disabled={loading}
  className={`
    px-4 py-2 rounded-lg text-sm font-medium text-white
    ${styles.button}
    ${loading ? "opacity-60 cursor-not-allowed" : ""}
  `}
>
  {loading ? "Processing..." : confirmText || "Confirm"}
</button>
  )}

</div>

      </div>
    </div>,
    document.body
  );
};

export default ConfirmDialog;

const instructions = (
  <div className="space-y-5">
    <div>
      <div className="font-semibold text-base mb-2">For Android/Chrome:</div>
      <ol className="list-decimal ml-6 space-y-1 text-gray-700">
        <li>Tap the <b>three dots</b> menu in your browser.</li>
        <li>Select <b>"Add to Home screen"</b> or <b>"Install app"</b>.</li>
        <li>Follow the prompts to add the app to your device.</li>
      </ol>
    </div>
    <div className="border-t border-gray-200 my-2"></div>
    <div>
      <div className="font-semibold text-base mb-2">For iPhone (Safari):</div>
      <ol className="list-decimal ml-6 space-y-1 text-gray-700">
        <li>Tap the <b>Share</b> icon at the bottom of Safari.</li>
        <li>Scroll down and tap <b>"Add to Home Screen"</b>.</li>
        <li>Tap <b>Add</b> in the top right corner.</li>
      </ol>
    </div>
    <div className="border-t border-gray-200 my-2"></div>
    <div>
      <span className="font-semibold">Note:</span> If you don't see the option, make sure you are using the latest version of your browser.
    </div>
  </div>
);
